import { Skeleton } from "@/components/ui/skeleton";

const Team = ({ team, loading }) => {
  if (loading) {
    return (
      <div>
        <Skeleton className="h-8 w-40 mb-4" />
        <Skeleton className="h-6 w-64 mb-8" />
        <div className="grid grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <Skeleton key={i} className="h-40 rounded-2xl" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div data-testid="team-section">
      <span className="text-[#2563EB] font-medium text-sm uppercase tracking-wider">
        Our Team
      </span>
      <h3 className="text-2xl sm:text-3xl font-bold text-slate-900 mt-2 mb-4">
        Meet the People Who
        <br />
        <span className="gradient-text">Make It Shine</span>
      </h3>
      <p className="text-slate-600 mb-8">
        Our professional team is dedicated to delivering exceptional cleaning
        services with a personal touch.
      </p>

      {/* Team Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {team.map((member) => (
          <div
            key={member.id}
            className="group relative overflow-hidden rounded-2xl"
            data-testid={`team-member-${member.id}`}
          >
            <div className="aspect-[3/4] overflow-hidden">
              <img
                src={member.image_url}
                alt={member.name}
                className="w-full h-full object-cover team-image group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            {/* Overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="font-semibold text-white text-sm sm:text-base">{member.name}</p>
              <p className="text-xs sm:text-sm text-white/80">{member.role}</p>
            </div>
          </div>
        ))}
      </div>

      {/* About Note */}
      <div className="mt-6 p-4 bg-[#2563EB]/5 rounded-xl border border-[#2563EB]/10">
        <p className="text-sm text-slate-600">
          <span className="font-accent text-lg text-[#2563EB]">Our Promise:</span>{" "}
          Every team member is background-checked, trained in eco-friendly methods,
          and committed to excellence.
        </p>
      </div>
    </div>
  );
};

export default Team;
